import { Accordion } from "react-bootstrap";
import Carousel from "react-bootstrap/Carousel";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronCircleRight } from "@fortawesome/free-solid-svg-icons";
import Link from "gatsby-link";
import * as React from 'react';
export default {
  Accordion,
  Carousel,
  FontAwesomeIcon,
  faChevronCircleRight,
  Link,
  React
};